import { render, staticRenderFns } from "./ApplicationScoring.vue?vue&type=template&id=c27316a8&"
import script from "./ApplicationScoring.vue?vue&type=script&lang=js&"
export * from "./ApplicationScoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports